<div class="section-title title-small on-surface-text">
  <span class="interest-section-title">Select interests</span>
  <mat-form-field subscriptSizing="dynamic" class="search-interest-field">
    <mat-icon matPrefix class="on-surface-text size-20 search-icon">
      search
    </mat-icon>
    <input #interestsFilterInput matInput [formControl]="filterFormControl" />
    @if (filterFormControl.value) {
      <button
        mat-icon-button
        matSuffix
        class="clear-button"
        (click)="filterFormControl.setValue('')"
      >
        <mat-icon class="size-20"> close </mat-icon>
      </button>
    }
  </mat-form-field>
</div>

<ng-container *vIf="!!interestsFilterInput.value">
  <span class="body-small on-surface-text italicized">Results</span>
</ng-container>

<ng-container *vIf="!interestsFilterInput.value">
  <span class="body-small on-surface-text italicized">Suggested</span>
</ng-container>

<mat-chip-listbox
  [multiple]="true"
  [class.multi-line]="$interestOptions().length > $lines()"
  [style.maxHeight]="$lines() * 40 + 'px'"
>
  @if ($showNewInterestChip()) {
    <mat-chip-option
      class="interest-chip"
      [selectable]="false"
      (click)="handleNewInterestClick()"
    >
      @if ($creatingInterest()) {
        <mat-spinner matChipAvatar [diameter]="18"></mat-spinner>
      } @else {
        <mat-icon matChipAvatar>add</mat-icon>
      }
      <span class="interest-chip-label">
        Create "{{ interestsFilterInput.value }}"
      </span>
    </mat-chip-option>
  }

  @for (
    option of $interestOptions();
    track option.interest.resourceName;
    let i = $index
  ) {
    <mat-chip-option
      class="interest-chip"
      [selected]="isOptionSelected(option)"
      (selectionChange)="handleInterestSelectionChange($event, option)"
    >
      <span matChipAvatar>
        {{ option.interest.emoji }}
      </span>
      <span class="interest-chip-label">
        <span class="interest-chip-name">{{ option.interest.name }}</span>
        <div>
          <span
            class="badge label-medium"
            *vIf="$showCountBadge(); animations: [VisibilityAnimation.FADE]"
          >
            <mat-icon class="size-13">notifications_active</mat-icon>
            {{ option.userCount }}
          </span>
          <span
            class="label-large flame"
            *vIf="
              !$showCountBadge() && i < 2;
              animations: [VisibilityAnimation.FADE]
            "
          >
            🔥
          </span>
          <span
            class="badge label-medium"
            *vIf="
              isOptionSelected(option);
              animations: [VisibilityAnimation.FADE]
            "
          >
            <mat-icon class="size-18">check</mat-icon>
          </span>
        </div>
      </span>
    </mat-chip-option>
  }
</mat-chip-listbox>

<div class="section-title body-small on-surface-text italicized">Selected</div>

@if (!selectedInterestsControl.value.length) {
  <span class="body-medium on-surface-text no-interests-selected">
    No interests selected
  </span>
} @else {
  <mat-chip-listbox
    [multiple]="true"
    [class.multi-line]="$selectedInterestOptions().length > 2"
    [style.maxHeight]="$selectedLines() * 40 + 'px'"
  >
    @for (
      option of $selectedInterestOptions();
      track option.interest.resourceName
    ) {
      <mat-chip-option
        class="interest-chip"
        [selected]="true"
        (selectionChange)="handleInterestSelectionChange($event, option)"
      >
        <span matChipAvatar>
          {{ option.interest.emoji }}
        </span>
        <span class="interest-chip-label">
          <span class="interest-chip-name">{{ option.interest.name }}</span>
          <div class="interest-chip-badges">
            <span
              class="badge label-medium"
              *vIf="$showCountBadge(); animations: [VisibilityAnimation.FADE]"
            >
              <mat-icon class="size-13">notifications_active</mat-icon>
              {{ option.userCount }}
            </span>
            <span
              class="badge label-medium"
              *vIf="
                isOptionSelected(option);
                animations: [VisibilityAnimation.FADE]
              "
            >
              <mat-icon class="size-18">check</mat-icon>
            </span>
          </div>
        </span>
      </mat-chip-option>
    }
  </mat-chip-listbox>
}
